import React from 'react';
import styled from 'styled-components';
import { Outlet, useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

const Wrap = styled.div`
  min-height: 100vh;
  background: #f5f7fa;
  display: flex;
  flex-direction: column;
`;

const Bar = styled.header`
  background: white;
  border-bottom: 1px solid #e5e7eb;
  padding: 0 20px;
  height: 56px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-shrink: 0;
  box-shadow: 0 1px 4px rgba(0,0,0,0.06);
`;

const AppName = styled.div`
  font-size: 17px;
  font-weight: 700;
  color: #111827;
  display: flex;
  align-items: center;
  gap: 10px;
`;

const RoleBadge = styled.span<{ $role: string }>`
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  padding: 2px 8px;
  border-radius: 20px;
  background: ${p => p.$role === 'cook' ? '#fff7ed' : '#eff6ff'};
  color: ${p => p.$role === 'cook' ? '#c2410c' : '#1d4ed8'};
`;

const Right = styled.div`display: flex; align-items: center; gap: 12px;`;

const UserName = styled.span`font-size: 14px; color: #6b7280;`;

const LogoutBtn = styled.button`
  padding: 6px 16px;
  border-radius: 8px;
  border: 1px solid #e5e7eb;
  background: white;
  color: #374151;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  &:hover { background: #f9fafb; }
`;

const Content = styled.main`
  flex: 1;
  padding: 20px 16px;
  overflow-y: auto;
`;

const roleLabel: Record<string, string> = { waiter: 'Cameriere', cook: 'Cucina' };

export default function StaffLayout() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    await logout();
    navigate('/login');
  };

  return (
    <Wrap>
      <Bar>
        <AppName>
          PubFreedom
          {user?.role && user.role !== 'admin' && (
            <RoleBadge $role={user.role}>{roleLabel[user.role] || user.role}</RoleBadge>
          )}
        </AppName>
        <Right>
          <UserName>{user?.username}</UserName>
          <LogoutBtn onClick={handleLogout}>Esci</LogoutBtn>
        </Right>
      </Bar>
      <Content>
        <Outlet />
      </Content>
    </Wrap>
  );
}
